"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
//
// Definition of user text select component
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTextSelectComponentParameters = void 0;
exports.UserTextSelectComponentParameters = [
    {
        id: 'options',
        label: 'Text Select Options',
        description: 'Input Param - List of available options for the user to select from',
        type: 'list',
        paramType: 'STRING_ARRAY',
        required: true,
    },
    {
        id: 'error',
        label: 'Error Message',
        description: 'Input Param - Message displayed when the entered value is not valid',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'type',
        label: 'Input Type',
        description: 'Input Param - Type of the keyboard to be shown',
        type: 'enum',
        list: {
            TEXT: 'Full keyboard with characters, alphabets, special characters, etc',
            INTEGER: 'KB only with Integers, (0-9)',
            FLOAT: 'KB only with Integers (0-9) and Decimal (.)',
        },
        paramType: 'ENUM',
        required: false,
    },
    {
        id: 'selected',
        label: 'Selected Option',
        description: 'Output Param - Stores the selected option chosen by the user',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
];
//# sourceMappingURL=UserTextSelectComponent.js.map